import 'url-polyfill';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/array';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill'; // to avoid - symbol is undefined error in IE
import 'custom-event-polyfill';
import AppRouter from './app-router';
import './styles-scss/app.css';

ReactDOM.render(<AppRouter />, document.getElementById('root'));
